// extracted by mini-css-extract-plugin
export var active = "_h4-7";
export var blink = "_h4-8";
export var dropDownSelector = "_h4-4";
export var dropDownWrapper = "_h4-3";
export var fakeCursor = "_h4-6";
export var fontSizeButton = "_h4-9";
export var formQuillEditor = "_h4-0";
export var pressed = "_h4-a";
export var qlBlank = "_h4-1";
export var textFormattingToolbar = "_h4-2";
export var textToolbarOption = "_h4-5";